import React, { Fragment } from 'react';

import Signin from './auth/signin';

import Publications from './components/publications/publications';
import PublicationsEdit from './components/publications/publicationsEdit';
import News from './components/news/news';
import Newsedit from './components/news/newsedit';
import Members from './components/members/members';
import Formquestion from './components/formquestion/formquestion';
import Formquestionedit from './components/formquestion/formquestionedit';

import DetalleConvencion from './components/asistentes/detalle-convencion'
import RutaProtegida from './components/RutaProtegida';
import AppLayout from './components/app';

import { Routes, Route, Navigate } from 'react-router-dom';
import Payment from './components/asistentes/registro-payment';

const NoAutorizado = () => {
  return <Fragment>
    <div>
      <h1>No tiene los permisos para ver este contenido</h1>
      <p>Laborum labore tempor fugiat dolore minim. Est commodo velit dolore eiusmod dolor. Pariatur occaecat nisi sint officia proident qui tempor. Sint commodo excepteur ullamco eiusmod eu do. Proident veniam aute proident dolor ipsum sit incididunt. Elit commodo est mollit laborum aute officia laborum dolore ex occaecat. Culpa occaecat aute nulla voluptate.</p>
    </div>
  </Fragment>
}

const RutasCMS = () => {
  return (
    <AppLayout>
      <Routes>
        {/* ============== RUTAS INTERNAS DEL CMS ============== */}
        <Route element={<RutaProtegida permisos={[15]} validarRuta={true} />}>
          <Route path='/registros/:evento/:tps' element={<Payment />} />
        </Route>

        <Route element={<RutaProtegida permisos={[15]} />}>
          <Route path='/detalle-convencion/:folio' element={<DetalleConvencion />} />
        </Route>

        {/* AGM */}

        <Route element={<RutaProtegida permisos={[16]} />}>
          <Route path='/publications' element={<Publications/>}/>
        </Route>

        <Route element={<RutaProtegida permisos={[16]} />}>
          <Route path='/publication-edit/:id' element={<PublicationsEdit/>}/>
        </Route>

        <Route element={<RutaProtegida permisos={[17]} />}>
          <Route path='/news' element={<News/>}/>
        </Route>

        <Route element={<RutaProtegida permisos={[17]} />}>
          <Route path='/news-edit/:id' element={<Newsedit/>}/>
        </Route>

        <Route element={<RutaProtegida permisos={[18]} />}>
          <Route path='/members' element={<Members/>}/>
        </Route>

        <Route element={<RutaProtegida permisos={[19]} />}>
          <Route path='/formquestion' element={<Formquestion/>}/>
        </Route>

        <Route element={<RutaProtegida permisos={[19]} />}>
          <Route path='/formquestion-edit/:id' element={<Formquestionedit/>}/>
        </Route>

        {/* ============== RUTA NO EXISTENTE ============== */}
        <Route path="*" element={<Navigate to={'/registros/1/1'} />} />
      </Routes>
    </AppLayout>
  )
}

function App() {
  return (
    <Routes>
      {/* ============== RUTAS PÚBLICAS ============== */}
      <Route path={`${process.env.PUBLIC_URL}/login`} element={<Signin />}/>
      <Route path={`${process.env.PUBLIC_URL}/no-autorizado`} element={<NoAutorizado />}/>
      {/* ============== RUTAS CON PERMISOS ============== */}
      <Route path='*' element={<RutasCMS />} />
    </Routes>
  );
}

export default App;